module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signContainer"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('img', {
    staticClass: "icon1",
    attrs: {
      "src": require("../assets/img/safe.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tipDetail2"
  }, [_vm._v("电子签名已做加密处理，请放心使用！")]), _vm._v(" "), _c('div', {
    staticClass: "mybutton1",
    on: {
      "click": _vm.clearHandler
    }
  }, [_vm._v("重签")]), _vm._v(" "), _c('div', {
    staticClass: "mybutton2",
    on: {
      "click": _vm.sureHandler
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _c('vue-esign', {
    ref: "VueEsignRef",
    staticClass: "vue-esign",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor,
      "isClearBgColor": false,
      "isCrop": _vm.isCrop,
      "format": _vm.format,
      "quality": _vm.quality
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tipDetail"
  }, [_vm._v(" 请将手机横屏，并且完成签名：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b739e30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignCanvas.vue
// module id = 504
// module chunks = 1